
import { Options, Vue } from 'vue-class-component'
import Clippy from './Clippy.vue'

import { strengths } from '@/util/phrases'
import { parseMarksIntoDOM } from '@/util/parse'
import { Mark } from '@/types/Mark'
import { Phrase } from '@/types/Phrase'

@Options({
    name: 'MessageText',
    data: function (): any {
        return {
            message: '',
            agent: null,
            agentShown: false,
        }
    },
    components: {
        Clippy,
    },
    updated(): void {
        this.scrollAll()
    },
    methods: {
        test: function () {
            console.log('hovering')
        },
        generateMarkStyle: (strength: number): any => ({
            backgroundColor: strengths[strength],
            opacity: .66
        }),
        messageChanged: function (e: InputEvent): void {
            // on message change by textarea event
        },
        onClickMark: function (event: MouseEvent, phrase: Phrase): void {
            // this.agent.stopCurrent()
            // this.agent.play(this.agent.animations()[2])

            // this.$refs.text.setCaretPosition(0)

            // document.elementFromPoint(event.clientX, event.clientY)?.click()

            this.$refs.clippy.move(event.clientX, event.clientY)
            this.$refs.clippy.speak(phrase.why)

            this.click(event.clientX, event.clientY)
        },
        click: function (x: number, y: number): void {
            const ev = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: true,
                screenX: x,
                screenY: y,
            })

            this.$refs.text.dispatchEvent(ev)
        },
        scrollAll: function (): void {
            for (const c of this.marks)
                if (c.id in this.$refs)
                    this.$refs[c.id].scrollTo(0, this.$refs.text.scrollTop)
        },
    },
    computed: {
        marks: function (): Array<Mark> {
            return parseMarksIntoDOM(this.message)
        },
    },
    watch: {
        message: function (v: string): void {
            v // do something with v
        },
    },
})
export default class MessageText extends Vue {}
